import { tenantId, webinarId } from "./sbase";
import { $subscriber, cr, interact, URLS, ck } from "fire-wind-water";
import comonService from "../services/comonService";
export default {
  isMobile() {
    return !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i);
  },

  setMettingInfo(webinarInfo, data, callback) {
    webinarInfo.webinarId = webinarId;
    webinarInfo.weChatId = data.wechatId;
    webinarInfo.instanceId = URLS.getURL("instanceId");
    webinarInfo.schemaId = data.schemaId;
    webinarInfo.webcastId = data.webcastId;
    webinarInfo.pcConfigId = data.templatePcConfigId;
    webinarInfo.wapConfigId = data.templateWapConfigId;
    webinarInfo.registrationFormId = data.registrationFormId;
    webinarInfo.shortUrl = data.wapUrl || data.enterShortUrl;
    webinarInfo.unLimitUrl = data.unLimitAttendWapUrl;
    webinarInfo.hlsUrl = data.hlsUrl;
    webinarInfo.rtmpUrl = data.rtmpUrl;
    webinarInfo.endTimeOffset = parseInt(data.endTimeOffset);
    webinarInfo.startTimeOffset = parseInt(data.startTimeOffset);
    webinarInfo.title = data.title;
    webinarInfo.intro = data.intro;
    webinarInfo.customPage = data.customPage;
    webinarInfo.adList = data.adList;
    webinarInfo.sponsor = data.sponsor;
    webinarInfo.logo = data.logoUrl.replace("https", "http");
    webinarInfo.logoRealPath = data.logoRealPath;
    webinarInfo.startTime = data.startTime * 1000;
    webinarInfo.endTime = data.endTime * 1000;
    webinarInfo.mainScreen = data.mainScreen;
    webinarInfo.status = data.status;
    webinarInfo.videoStatus = data.videoStatus;
    webinarInfo.needLogin = parseInt(data.needLogin) === 1;
    // webinarInfo.needLogin = false;
    webinarInfo.isSilent = parseInt(data.isSilent) === 1;
    webinarInfo.isReleased = parseInt(data.isReleased) === 1;
    webinarInfo.agendaList = data.agendaList;
    webinarInfo.questionaryId = data.questionnaireId;
    webinarInfo.guestList = data.guestList;
    webinarInfo.posterStatus = data.posterStatus;
    webinarInfo.replaySwitch = data.replaySwitch;
    webinarInfo.pollId = data.pollId;
    webinarInfo.unLimit =
      parseInt(data.unLimit) === 1 &&
      (URLS.getURL("unLimit") ? eval(URLS.getURL("unLimit")) : false);
    webinarInfo.needRegistration =
      parseInt(data.enableSignUpForm) === 1 && parseInt(data.isSilent) === 0;
    if (
      webinarInfo.serverTime <
      webinarInfo.startTime - webinarInfo.startTimeOffset * 60 * 1000
    ) {
      webinarInfo.isOpen = false;
    } else {
      webinarInfo.isOpen = true;
    }
    if (
      webinarInfo.serverTime >
      webinarInfo.endTime + webinarInfo.endTimeOffset * 60 * 1000
    ) {
      webinarInfo.isClosed = webinarInfo.replaySwitch !== 1;
    } else {
      webinarInfo.isClosed = false;
    }
    webinarInfo.isOnDemand =
      data.demandUrl !== null && data.demandUrl !== undefined;
    webinarInfo.demandInfoUrl = data.demandUrl
      ? this.isMobile()
        ? data.demandUrl.wapUrl
        : data.demandUrl.pcUrl
      : undefined;
    webinarInfo.demandUrl = data.demandUrl
      ? this.isMobile()
        ? data.demandUrl.liveWapUrl
        : data.demandUrl.livePcUrl
      : undefined;
    webinarInfo.globalUserId = "";
    webinarInfo.storageKey = undefined;
    webinarInfo.isSetUserName = parseInt(data.isSetUserName) === 1;
    webinarInfo.isAllowMessage = parseInt(data.isAllowMessage) === 1;
    webinarInfo.shareSummary = data.shareSummary;
    webinarInfo.webCastProvider = data.webCastProvider;
    webinarInfo.folderId = data.folderId;
    webinarInfo.livePcUrl = data.livePcUrl;
    webinarInfo.liveWapUrl = data.liveWapUrl;
    webinarInfo.shareCoverUrl = data.shareCoverUrl;
    webinarInfo.logoRealPath = data.logoRealPath;
    webinarInfo.shareTitle = data.shareTitle;
    webinarInfo.canShare = data.canShare;
    webinarInfo.signupEndWapUrl = data.signupEndWapUrl;
    webinarInfo.signupEndPcUrl = data.signupEndPcUrl;
    webinarInfo.canShare = data.canShare;
    webinarInfo.shareCoverUrl = data.shareCoverUrl;
    webinarInfo.logoRealPath = data.logoRealPath;
    webinarInfo.shareTitle = data.shareTitle;
    if (Object.prototype.hasOwnProperty.call(data, "isPolyvHavePpt")) {
      webinarInfo.isPolyvHavePpt = data.isPolyvHavePpt;
    } else {
      webinarInfo.isPolyvHavePpt = true;
    }
    if (URLS.getURL("tc")) {
      this.getTcShortUrl(webinarInfo);
    } else {
      $subscriber.emit("webinarInfo", webinarInfo);
    }
    $subscriber.emit("onCountdown", webinarInfo.serverTime);
    callback(webinarInfo);
  },
  //长链接转短地址
  getTcShortUrl(webinarInfo) {
    let info = {
      tc: URLS.getURL("tc"),
      webinarId: webinarInfo.webinarId
    };
    comonService.getTcShortUrl(info).subscribe(data => {
      if (data && data.content && data.content.shortUrlInfoWap) {
        webinarInfo.shortUrl =
          data.content.shortUrlInfoWap || webinarInfo.shortUrl;
      }
      $subscriber.emit("webinarInfo", webinarInfo);
    });
  },
  // 获取模板配置信息
  getTemplateConfig(meetingInfo) {
    this.service
      .getTemplateConfig({
        tenantId: tenantId,
        configId:
          interact.isMobile === 1
            ? meetingInfo.templateWapConfigId
            : meetingInfo.templatePcConfigId
      })
      .subscribe(data => {
        if (data.result === 0 && data.content) {
          cr.each(data.content.configInfo.html, item => {});
        }
      });
  },

  //侦听数据变化
  ListenDataChange() {
    window.$sk.webinar.module({
      skMeetingChange(res) {
        console.log(`%c 监听sk 发的 会议信息`, "color:blue", res);
      },
      skMeetingLinkStart(res) {
        console.log(`%c 跳转之前`, "color:blue");
      },
      showUserNameDialog() {
        const webianr = window.$sk.webinar.get().meetingInfo;
        const userInfo = window.$sk.webinar.get().user;
        //无限制观看，未登录报名，未设置用户名
        if (
          webianr.unLimit &&
          webianr.isSetUserName &&
          userInfo.temporaryUserName == ""
        ) {
          if (
            !userInfo.isLogin &&
            (!userInfo.isRegistration ||
              (userInfo.isRegistration && userInfo.isUnLimit))
          ) {
            $subscriber.emit("showSetUserName", true);
          } else {
            $subscriber.emit("showSetUserName", false);
          }
        }
      },
      //若是 无限制  清cokke
      onUnLimitRegistration(res) {
        $subscriber.emit("onUnLimitRegistration", res);
      }
    });
  }
};
